export const PRODUCTS = [
  "Arts, crafts adn collectibles",
  "Automotive",
  "CBD",
  "Charities, donations & non profit organisations",
  "Classifieds",
  "Consumer electronics",
  "Crypto Exchanges & related businesses",
  "Dating & Social Netwirk Services",
  "Digital Advertising",
  "Digital Goods (Games, Software VOD, ePublishing)",
  "Education",
  "Energy & Utilities (Telcom, ISP, TVs, Electricity)",
  "Fashion (Apparel, Footwear, Accessories)",
  "File Sharing Services",
  "Financial Services",
  "Fitness, Sport & Recreation",
  "Food Delivery",
  "Forex, Financial Advisory, Investment Services",
  "Furniture & Appliances",
  "Gambling",
  "Grocery",
  "Healthcare: Health, Beauty & Wellness",
  "Home & Garden",
  "Insurance",
  "Jewelery",
  "Loots",
  "Marketplace",
  "Mobile app",
  "Mobility",
  "Online Travel Agency",
  "Physical Media (Books, Movies, Music, Games)",
  "Retail Merchandise Sales",
  "Services (SaaS)",
  "Skins",
  "Social Media Boosting",
  "Supplements, Vitamins",
  "Ticketing & Events",
  "Toys, Hobby & DIY",
  "Transportation (aggregator)",
  "Vaping",
  "VPN",
  "Wholesale",
].map((product) => ({
  label: product,
  value: product,
}))

export const MONTHLY_TURNOVER = [
  "0 - 4 999",
  "5 000 - 9 999",
  "10 0000 - 19 999",
  "20 000 - 49 999",
  "50 000 - 99 999",
  "Over 500 000",
].map((turnover) => ({
  label: `${turnover} EUR`,
  value: `${turnover} EUR`,
}))
